export enum ApplicationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  BLOCKED = 'BLOCKED'
}

export interface RestaurantResponse {
  id: number;
  name: string;
  phone: string;
  description: string;
  workStartTime: string;
  workEndTime: string;
  isOpen: boolean;
  bannerImageId: string;
  applicationStatus: ApplicationStatus;
  applicationStatusBlockReason: string;
  balance: number;
  rating: number;
}

export interface RestaurantBranchResponse {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  representativeName: string;
  phone: string;
}

export interface RestaurantFoodResponse {
  id: number;
  name: string;
  description: string;
  price: number;
  isAvailable: boolean;
  foodImage: string | null;
}

export interface RestaurantCategoryWithFoodsResponse {
  categoryName: string;
  categoryId: number;
  foods: RestaurantFoodResponse[];
}

export interface RestaurantDetailsResponse {
  restaurant: RestaurantResponse;
  branches: RestaurantBranchResponse[];
  categoriesWithFoods: RestaurantCategoryWithFoodsResponse[];
}

export interface RestaurantsRequest {
  searchQuery: string;
  page: number;
  pageSize: number;
  applicationStatus: ApplicationStatus | null;
}

export interface ChangeRestaurantApplicationStatusRequest {
  restaurantId: number;
  applicationStatus: ApplicationStatus;
  blockReason: string | null;
}

export interface ChangeRestaurantBalanceRequest {
  restaurantId: number;
  balance: number;
}

export enum CommissionType {
  FIXED = 'FIXED',
  TIERED = 'TIERED'
}

export interface CommissionTier {
  id?: number;
  orderThreshold: number;
  percentage: number;
  priority: number;
}

export interface CommissionTierRequest {
  orderThreshold: number;
  percentage: number;
}

export interface RestaurantCommissionConfig {
  restaurantId: number;
  commissionType: CommissionType;
  fixedPercentage?: number;
  tiers: CommissionTier[];
}

export interface SetRestaurantCommissionRequest {
  restaurantId: number;
  commissionType: CommissionType;
  fixedPercentage?: number;
  tiers?: CommissionTierRequest[];
}

export enum TransactionType {
  FILL = 'FILL',
  WITHDRAW = 'WITHDRAW'
}

export interface RestaurantTransaction {
  id: number;
  restaurantId: number;
  transactionType: TransactionType;
  amount: number;
  descriptionHtml: string;
  createdAt: number;
  isDeleted: boolean;
}

export interface RestaurantTransactionsResponse {
  transactions: RestaurantTransaction[];
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export interface CreateRestaurantTransactionRequest {
  restaurantId: number;
  transactionType: TransactionType;
  amount: number;
  descriptionHtml: string;
}

export interface CreateRestaurantTransactionResponse {
  transactionId: number;
}
